import axios from 'axios';
import aesEncryptionService from '../services/aesEncryptionService';
import appConfig from '../config/appConfig';

interface EncryptedApiResponse {
  encryptedBody: string;
}

const headers = {
  'Content-Type': 'application/json',
  'API-ClientID': appConfig.API_ClientID,
  'API-ClientSecret': appConfig.API_ClientSecret,
  Accept: 'application/json',
};

const buildRequestBody = (payload: object) => ({
  application: 'PSGLOGIN',
  date: new Date().toISOString().split('T')[0],
  encryptedBody: aesEncryptionService.encryptData(payload),
});

export const getStaffById = async (staffId: string) => {
  try {
    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/userDet`,
      buildRequestBody({ staff_id: staffId }),
      { headers }
    );
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    return decrypted;
  } catch (error) {
    console.error('getStaffById Error:', error);
    throw new Error('Staff details not found.');
  }
};

export const sendSignupOtp = async (type: 'email' | 'mobile', value: string) => {
  try {
    const payload = type === 'email' ? { email: value } : { mobile: value };
    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/otp/send`,
      buildRequestBody(payload),
      { headers }
    );
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    console.log("decrypted", decrypted);
    return decrypted;
  } catch (error) {
    console.error('sendSignupOtp Error:', error);
    throw new Error('OTP sending failed.');
  }
};

export const verifySignupOtp = async (type: 'email' | 'mobile', value: string, otp: string) => {
  try {
    const payload: any = { userotp : otp , newuser:"Y"};
    if (type === 'email') payload.email = value;
    else payload.mobile = value;


    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/otp/verify`,
      buildRequestBody(payload),
      { headers }
    );
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    console.log("verifySignupOtp", decrypted)
    return decrypted;
  } catch (error) {
    console.error('verifySignupOtp Error:', error);
    throw new Error('OTP verification failed.');
  }
};

export const checkLoginIdExists = async (loginId: string): Promise<EncryptedApiResponse | null> => {
  try {
    const payload = { login_id: loginId };
    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/loginverify`,
      buildRequestBody(payload),
      { headers }
    );

    // Decrypt the response
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    return decrypted; 
  } catch (error) {
    console.error("checkLoginIdExists Error:", error);
    return null;
  }
};

export const insertUser = async (userData: any) => {
  try {
    const response = await axios.post<EncryptedApiResponse>(
      `${appConfig.API_BASE_URL}/userinsert`,
      buildRequestBody(userData),
      { headers }
    );
    const decrypted = aesEncryptionService.decryptData(response.data.encryptedBody);
    return decrypted;
  } catch (error) {
    console.error('insertUser Error:', error);
    throw new Error('User registration failed.');
  }
};

